import { Button, Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import T from 'i18n';
import SearchInput from './SearchInput';
import SearchInfo from './SearchInfo';

interface NewSearchContainerProps {
  handleSearch: (input: string, filters: any, outputType?: string) => void;
  filters: any;
  askAIHandler: any;
  fileSidebarAskAI: boolean;
  file: any;
  fileData?: any;
  directAnswers?: boolean;
  askAiSearchType?: string;
  initialOutputFormat?: string;
  onOutputFormatChange?: (format: string) => void;
}

export const NewSearchContainer: React.FC<NewSearchContainerProps> = ({
  filters,
  handleSearch,
  fileSidebarAskAI,
  file,
  fileData,
  directAnswers,
  askAiSearchType,
  initialOutputFormat,
  onOutputFormatChange,
}) => {
  const [summaryTopic, setSummaryTopic] = React.useState<null | string>(null);

  useEffect(() => {
    if (summaryTopic && summaryTopic === filters.phrase) {
      handleSearch(filters.phrase, filters);
      setSummaryTopic(null);
    }
    return () => {
      setSummaryTopic(null);
    };
  }, [summaryTopic, filters.phrase, handleSearch, filters]);
  return (
    <>
      <Grid
        container
        height="100%"
        sx={{
          alignContent: 'center',
          justifyContent: 'center',
          mt: fileSidebarAskAI ? '-0.5rem' : '-4.5rem',
        }}
        spacing={1}
      >
        {!fileSidebarAskAI && (
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h3" sx={{ color: '#212529', fontWeight: 700 }}>
              {T.translate('case.enterTopicHeading')}
            </Typography>
            {!directAnswers && (
              <Button
                style={{
                  padding: 0,
                  height: 'fit-content',
                  minWidth: 0,
                }}
              >
                <SearchInfo isNewSearch={true} />
              </Button>
            )}
          </Grid>
        )}
        <Grid item xs={12} sx={{ paddingLeft: '5px !important', paddingRight: '10px' }}>
          <SearchInput
            askAiSearchType={askAiSearchType}
            isAnswersMode={false}
            isNewSearch={true}
            handleSearch={handleSearch}
            fileSidebarAskAI={fileSidebarAskAI}
            file={file}
            inputFilters={filters}
            fileData={fileData}
            directAnswers={directAnswers}
            initialOutputFormat={initialOutputFormat}
            onOutputFormatChange={onOutputFormatChange}
          />
        </Grid>
      </Grid>
    </>
  );
};
